import * as R from 'ramda'
import moment from 'moment'
import breakdown from './breakdown'

export default (history, properties, date = new Date()) => {
	let historyByPropertyID = R.pipe(R.values, R.groupBy(R.prop('propertyID')))(history)

	let res = R.mapObjIndexed((propertyHistory, propertyID) => {
		let latestHistory = R.pipe(R.sortBy(R.prop('date')), R.findLast(x => x.date <= moment(date).format('YYYY-MM-DD')))(propertyHistory)
		let balance = breakdown(properties, moment(date).format('YYYY-MM-DD'))[propertyID].balance
		let equity = latestHistory.price * 0.95 - balance
		return equity
	})(historyByPropertyID)
	res.total = R.pipe(R.values, R.reduce(R.add, 0))(res)

	return res
}

export let equityProperty = (history, properties) => {
	let historyByPropertyID = R.pipe(R.values, R.groupBy(R.prop('propertyID')))(history)
	let equityTotal = 0, gainTotal = 0
	let res = R.map(property => {
		let propertyHistory = historyByPropertyID[property._id] || []
		let h1 = R.findLast(x => (x.date == "2017-07-01T00:00:00.000Z"))(propertyHistory) || {price: 0}
		let h2 = R.findLast(x => (x.date == "2016-12-01T00:00:00.000Z"))(propertyHistory) || {price: 0}
		equityTotal += h1.price;
		gainTotal += h1.price - h2.price;
		return {equity: h1.price, gain: h1.price - h2.price}
	})(properties)
	res.total = {equity: equityTotal, gain: gainTotal}
	return res
}



// WEBPACK FOOTER //
// ./src/helpers/kpi/equity.js